import _defineProperty from "/app/workspaces/v_1/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
// @ts-check
import { debounce } from '../blocks/utils/debounce.js';
const WINDOW_HEIGHT_TRACKER_PROPERTY = '--uploadcare-blocks-window-height';
export class WindowHeightTracker {
  /**
   * @param {unknown} client
   * @public
   */
  static registerClient(client) {
    if (this.clientsRegistry.size === 0) {
      this.attachTracker();
    }
    this.clientsRegistry.add(client);
  }

  /**
   * @param {unknown} client
   * @public
   */
  static unregisterClient(client) {
    this.clientsRegistry.delete(client);
    if (this.clientsRegistry.size === 0) {
      this.detachTracker();
    }
  }

  /** @private */
  static attachTracker() {
    window.addEventListener('resize', this.flush, {
      passive: true,
      capture: true
    });
    this.flush();
  }

  /** @private */
  static detachTracker() {
    window.removeEventListener('resize', this.flush, {
      capture: true
    });
    document.documentElement.style.removeProperty(WINDOW_HEIGHT_TRACKER_PROPERTY);
  }
}
/**
 * @private
 * @type {Set<unknown>}
 */
_defineProperty(WindowHeightTracker, "clientsRegistry", new Set());
/** @private */
_defineProperty(WindowHeightTracker, "flush", debounce(() => {
  document.documentElement.style.setProperty(WINDOW_HEIGHT_TRACKER_PROPERTY, "".concat(window.innerHeight, "px"));
}, 100));